import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import * as actions from '../../actions/index';
//image
import vuepay_large_logo from '../../assets/images/vuepaylogonav@5x.png';
import loading_white from '../../assets/gif/loading_white.gif';
//internal js
import CryptoJS from 'crypto-js';
import { Link } from 'react-router-dom';
import { isValidPassword, vuepayAlert, isEmpty, vuePayLog } from "../../util/utility";
import { checkIfRegister, renderField } from "../../util/account_management";
import strings from "../../util/strings";
import { get as _get } from "lodash";

// import {getData, LOGIN, setData, USER_DATA} from "../../util/storage";

import { LOGIN, redirectIfSessionExist, getData, setData } from "../../util/storage";
import { doMoneyBloxLogin } from "../../assets/libs/MoneyBlox";

class Signup extends Component {

    required = value => (value ? undefined : 'Required');

    constructor(props) {
        super(props);
        this.state = {
            type: 'password',
            confType: 'password',
            class_name: 'btn btn-pwd-hide',
            class_name_conf: 'btn btn-pwd-hide',
            confirmPasswordError: false,
            moneyBloxData: null,
            validForm: false
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.showHidePassword = this.showHidePassword.bind(this);
        this.showHidePasswordConf = this.showHidePasswordConf.bind(this);
        this.validateUsername = this.validateUsername.bind(this)
        this.validatePromocode = this.validatePromocode.bind(this)
    }

    componentDidMount() {
        document.getElementsByClassName("modal-overlay")[0].style.display = "inherit";
        redirectIfSessionExist((is_session_valid) => {
            if (is_session_valid) {
                this.props.history.push("/dashboard");
            }
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        if (checkIfRegister(nextProps)) {
            if (nextProps.account_management.register.status_code === 200) {
                vuepayAlert("success", nextProps.account_management.register.message, () => {

                    setData(LOGIN, nextProps.account_management.register.data)
                    doMoneyBloxLogin(this.state.moneyBloxData);
                    _get(nextProps, 'account_management.register.data.2fa_required') == 1 ? nextProps.history.push("/verify-mobile", {
                        api_token: nextProps.account_management.register.data.api_token,
                        token: nextProps.account_management.register.data.token,
                        userData: nextProps.account_management.register.data,
                        isGolive: this.props.location.state.isGolive,
                        parentPath: {
                            basePath: nextProps.history.location.state.parentPath ? nextProps.history.location.state.parentPath.basePath : nextProps.history.location.state.basePath,
                            search: nextProps.history.location.state.parentPath ? nextProps.history.location.state.parentPath.search : nextProps.history.location.state.search
                        }
                    }) : nextProps.history.push("/login");
                    nextProps.resetRegister();
                    getData(LOGIN)
                        .then((data) => {
                            if (!isEmpty(data)) {
                                nextProps.getUserDetails(data.token, data.api_token);
                                nextProps.getFollowingList(data.token, data.api_token, "", "")
                            }
                        })
                });
            } else {
                vuepayAlert("error", nextProps.account_management.register.message, () => {
                    nextProps.resetRegister();
                });
            }
        }
    }

    onSubmit(values) {

        vuePayLog(__filename, "onSubmit :: values", values);

        const data = {
            username: values.username,
            email: values.email,
            password: CryptoJS.MD5(values.password).toString(),
            device: this.props.device,
            age_group: values.age_group,
            promocode:values.promocode
        };
        this.setState({
            moneyBloxData: {
                login: values.username,
                password: CryptoJS.MD5(values.password).toString(),
                device: this.props.device,
            }
        })
        vuePayLog(__filename, "onSubmit :: data", data);
        this.state.validForm && this.props.termscondition && this.props.register(data);
    }

    //this function helps to toggle the state of password
    showHidePassword = () => {
        this.setState({
            type: this.state.type === 'input' ? 'password' : 'input',
            class_name: this.state.type === 'input' ? 'btn btn-pwd-hide' : 'btn btn-pwd-show'
        })
    };

    showHidePasswordConf = () => {
        this.setState({
            confType: this.state.confType === 'input' ? 'password' : 'input',
            class_name_conf: this.state.confType === 'input' ? 'btn btn-pwd-hide' : 'btn btn-pwd-show'
        })
    };

    validateUsername(e) {
        //username has  to be more than 2 characters to get checked with web service
        if (e.target.value.length > 2) {
            this.props.validateUsername(e.target.value);
        }
    }

    validatePromocode(e) {
        if (e && e.length > 0) {
            this.props.validatePromocode(e);
            this.setState({
                validForm: this.props.account_management.promocodevalid
            })
        } else {
            this.props.resetPromoCode();
            this.setState({
                validForm: true
            })
        }
    }

    validateConfermPassword = (e) => {
        //console.log("inside this.validateConfermPassword:::", this.props.formData.password, "::e.target.value:", e.target.value);
        if (_get(this.props, 'formData.password', '') != _get(e, 'target.value', '')) {
            this.setState({
                confirmPasswordError: true,
                validForm: false
            })
        } else {
            this.setState({
                confirmPasswordError: false,
                validForm: true
            })
        }

        // if()

    }

    validUsername = value =>
        value && !/^[a-z0-9](?!.*?[^\na-z0-9]{2}).*?[a-z0-9]$/i.test(value) ?
            'Invalid username' : undefined;

    render() {


        const { confirmPasswordError } = this.state

        const { handleSubmit, location, error } = this.props;
        const basePath = _get(location, 'state.basePath', '')
        const isGolive = _get(location, 'state.isGolive', false)


        return (
            <div>
                <main role="main" className="">
                    <div className="login-container">
                        <div className="popup-header">
                            <button type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => {
                                    document.getElementsByClassName("modal-overlay")[0].style.display = "none"

                                    if (this.props.location.state.hasOwnProperty("parentPath")) {
                                        this.props.history.push(
                                            {
                                                pathname: _get(this.props, 'location.state.parentPath.basePath', ''),
                                                search: _get(this.props, 'location.state.parentPath.search', ''),
                                                state: {
                                                    basePath: this.props.location.state.parentPath.basePath,
                                                    search: _get(this.props, 'location.state.parentPath.search', '')
                                                }
                                            }
                                        );
                                    } else {
                                        this.props.history.push(
                                            {
                                                pathname: _get(this.props, 'location.state.basePath', ''),
                                                search: _get(this.props, 'location.state.search', ''),
                                                state: {
                                                    basePath: this.props.location.state.basePath,
                                                    search: _get(this.props, 'location.state.search', '')
                                                }
                                            }
                                        );
                                    }
                                }
                                }
                            >
                                <img alt={"close-icon"} src={"https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/close.svg"} />
                            </button>

                        </div>
                        <div className="row" style={{ position: "relative" }}>
                            {
                                isGolive ?
                                    <div className="col-md-6 bg-primary d-flex align-items-center text-center"
                                        style={{ borderRight: '1px solid #e7e7e7' }}>
                                        <div className="login-content">
                                            <img src={vuepay_large_logo} className="img-fluid" />
                                            <h4 style={{ color: '#FFFFFF' }}>{strings.broadcaster.register_to_become_a_broadcaster_left_area_title}</h4>
                                            <p style={{ color: '#FFFFFF' }}>{strings.broadcaster.register_to_become_a_broadcaster_left_area_subtitle}</p>

                                        </div>
                                    </div> :
                                    <div className="col-md-6 bg-primary d-flex align-items-center text-center" style={{ borderRight: '1px solid #e7e7e7' }}>
                                        <img src={vuepay_large_logo} alt={"VuePay"} className="img-fluid" />
                                    </div>
                            }
                            <div className="col-md-6 bg-white d-flex align-items-center">
                                <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                    <h4>Sign up</h4>
                                    <Field
                                        label="Username"
                                        name="username"
                                        type="text"
                                        height={"47px"}
                                        username={this.props.account_management}
                                        validate={[this.required, this.validUsername]}
                                        component={renderField}
                                        onBlur={this.validateUsername}
                                    />
                                    <Field
                                        label="Email"
                                        name="email"
                                        type="email"
                                        email={true}
                                        height={"47px"}
                                        username={null}
                                        validate={[this.required]}
                                        component={renderField}
                                    />
                                    <Field
                                        label="Password"
                                        name="password"
                                        type={this.state.type}
                                        username={null}
                                        height={"47px"}
                                        is_password={true}
                                        password_class={this.state.class_name}
                                        buttonClick={this.showHidePassword}
                                        validate={[this.required, isValidPassword]}
                                        component={renderField}
                                    />
                                    <br />
                                    <Field
                                        label="Confirm Password"
                                        name="confirmPassword"
                                        type={this.state.confType}
                                        username={null}
                                        height={"47px"}
                                        is_password={true}
                                        password_class={this.state.class_name_conf}
                                        buttonClick={this.showHidePasswordConf}
                                        validate={[this.required]}
                                        component={renderField}
                                        onBlur={this.validateConfermPassword}
                                    />
                                    {confirmPasswordError && <span className="text-danger">{strings.valid.confirmPassword}</span>}

                                    <br />
                                    <Field
                                        label="Promo Code"
                                        name="promocode"
                                        type="text"
                                        height={"47px"}
                                        username={null}
                                        validate={this.validatePromocode}
                                        component={renderField}
                                        normalize={(value, previousValue, allValues, previousAllValues) => {
                                            console.log(value);
                                            return value ? value.toLowerCase() : '';
                                        }}
                                    />
                                    {
                                        (!error && (this.props.account_management && this.props.account_management.promocode) &&
                                            ((this.props.account_management.promocode.status_code !== 200) ?
                                                <span className="text-danger">{this.props.account_management.promocode.message}</span> :
                                                <span className="text-success">{this.props.account_management.promocode.message}</span>))
                                    }

                                    <br /><br />
                                    <label style={{ fontWeight: "bold" }}>Age</label>
                                    <div>
                                        <label className="ageGroup"><Field name="age_group" component="input" type="radio" value="less_than_12" /> Under 12</label>
                                        <label className="ageGroup"><Field name="age_group" component="input" type="radio" value="more_than_12" /> 12+</label>
                                        <label className="ageGroup"><Field name="age_group" component="input" type="radio" value="more_than_15" /> 15+</label>
                                        <label className="ageGroup"><Field name="age_group" component="input" type="radio" value="18" /> 18</label>
                                    </div>
                                    <div style={{marginTop:"10px"}}>
                                    <label className="ageGroup">
                                        <Field
                                            name="termscondition"
                                            component="input"
                                            validate={[this.required]}
                                            type="checkbox"
                                        /> I Accept <a href="https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/EULA/terms.html" target="_blank" style={{color:"#1B75BC"}}>Terms & Condition</a> & <a href="https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/EULA/terms.html" target="_blank" style={{color:"#1B75BC"}}>Privacy Policy</a>
                                        </label>
                                    </div>
                                    {error && <strong>{error}</strong>}
                                    <div className="mt-4 text-center">
                                        <button className="btn btn-primary">
                                            {
                                                this.props.account_management.isFetching
                                                    ?
                                                    <img src={loading_white} alt={"Loading"} width={26} height={26} />
                                                    :
                                                    'Sign up'
                                            }
                                        </button>
                                    </div>
                                </form>
                            </div>
                            {
                                !isGolive && <div className="back-btn">
                                    <Link to={{
                                        pathname: '/login',

                                        state: { "basePath": basePath }
                                    }}
                                        title="Back"></Link>
                                </div>
                            }
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const selector = formValueSelector('SignupForm');
    return {
        account_management: state.account_management,
        device: state.device.payload,
        formData: _get(state, 'form.SignupForm.values', null),
        initialValues: {
            name: '',
            email: '',
            password: '',
            confirmPassword: ''
        },
        termscondition : selector(state, "termscondition")
    };
}

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
Signup = reduxForm({
    form: 'SignupForm', // a unique identifier for this form
    enableReinitialize: true,
})(Signup)

// You have to connect() to any reducers that you wish to connect to yourself
Signup = connect(
    mapStateToProps, // pull initial values from account reducer
    actions // bind account loading action creator
)(Signup)

export default Signup